/*
 File: init-slideshow.js
 Author: D McCleod
 Created: 2/24/2017
 Modified: 1/24/2019
 Description: initialize modules and slide show events, called in dom ready
 */

import { infiniteScrollTracking } from './infinitescroll-tracking';
import { initShareWidget } from './share-widget';
import { initModularTracking } from './slide-tracking';
import { pagination } from './pagination';
import { BrowserClass } from './browser-class';
import { addLazyData } from './image-aspect';
import { overlayMng } from './overlays.js';
import { sticky } from './sticky-header';
import { initEmailFeedback } from './email-feedback';
import { interAd } from './interstitial-ad';
import { contentMarketing } from './content-mrk-ad';
import { lazyLoadInfiniteScroll,lazyLoadSlickSlider } from './lazy-load';
import { instreamAd } from './instream-ad';
import './commenting';
import * as hashManager from './hash-manager';
import * as config from './config';

if (! window._babelPolyfill) {
  require("babel-polyfill");
}

window.slideShow = window.slideShow || {};
window.slideShow.cononical = [location.protocol, '//', location.host, location.pathname].join('');
window.slideShow.slickNavEngaged = false;
window.slideShow.interstitialCount = 0;
window.slideShow.triggers = {};
window.slideShow.environment = {
    env: undefined,
    host: {
        local: 'localhost',
        dev: 'dev0',
        qa: 'qa0',
        staging: 'staging'
    },
    getEnv: function(){
        let loc = location.host;
        for(let i in this.host){
            if(loc.indexOf(this.host[i])!== -1){
                this.env = i;
            }
        }
        this.env = this.env === undefined ? 'live' : this.env;
        return this.env;
    }
};
window.slideShow.navEvent = {
    type: '',
    data: ''
};

window.slideShowVars.hasInterstitial = true;
window.slideShow.header = $('#headerbox');
window.slideShow.navHeader = $('.crs-top');

const isLocal = location.hostname === 'localhost';

let isInfiniteScroll = false;
let notInfiniteScroll = true;

function initSlideshow() {
    const body = document.getElementsByTagName('body')[0];
    // if infiniteScroll is present, may have values of: web" "mobile" or "both"
    isInfiniteScroll = window.slideShowVars.infiniteScroll === undefined ? false : (window.breakpoint === 1);
	notInfiniteScroll = !isInfiniteScroll;

    window.slideShow.initialSlide = (isInfiniteScroll || window.isMscpApp) ? 0 : hashManager.getHash() - 1;

    // initialize functions from imports
    hashManager.bindHashListener();
    pagination.init();
    initModularTracking();
    initShareWidget();
    BrowserClass();
    overlayMng.init();
    initEmailFeedback();

    if(isLocal){
        // simulate ad loading delay
        setTimeout(function(){
            sticky.init({
                disable_sticky: window.bDisableSticky !== undefined
            });
        }, 1500);

        // because tracking calls are not available on local, assign a $noop value so no errors are thrown
        let trackCalls = [
            'wmdTrack',
            'wmdPageview',
            'wmdPageLink',
            'BItrack',
            'pageRefresh',
            'GenPVID',
            'cpArticleLoad',
            ['webmd','ads','defineAd']
        ].map(function(val){
            val = typeof val === 'object' ? val.join('.') : val;
            window[val] = typeof window.val !== 'function' ? $.noop : window.val;
            return window.val;
        });
    } else {
        // temp detection for ad blocker
        // TODO: update https://img.qa02.medscapestatic.com/medscape-core/shared-all/js/vendor/medscape-vt.js and add a global object: mscp = mscp || {}; inside of the window.pf_notify function, so other scripts can detect with out checking for cookie value
        // when the cookie 'gab' is equal to 1, the ad blocker is present, ex: parseFloat($.cookie('gab')) === 1
        //set sticky props before images finish loading
        sticky.props = sticky.props || {};

        // wait until add iframe loads before init call, needed to detect proper scroll height
        $(document).one('dfpRenderComp', function () {
            sticky.init({ disable_sticky: window.bDisableSticky !== undefined });
        });
    }

    // iterate over all images and create data-lazy attribute, based on data-aspect1 or data-aspect2 values, depending on break point
    // call checkMediaQuery to check breakpoint
    $(window).on('lazydata:loaded', function() {
        window.slideShow.initialSlide = (isInfiniteScroll || isMscpApp) ? 0 : hashManager.getHash() - 1;
        slideShow.useContentMrk = contentMarketing.checkQueryString(contentMarketing);

        // insert content marketing ad container based on ecd query string
        if(slideShow.useContentMrk && breakpoint === 1 && !isInfiniteScroll) {
            config.slideShowWrapper.addClass(contentMarketing.slideContentClass);
            contentMarketing.buildAdContainer(config.slideContainer);
        }
        if(isMscpApp) {
            // add app specific classname, jquery .addClass caused unknown error
            body.classList.add('mscpapp');
            // prevent swipe in app
            config.configObj.swipe = false;
        }

        //add classes based on template vars in slideShowVars {}
        config.slideShowWrapper
            .addClass(slideShowVars.ppt !== undefined ? 'has-power-point' : '')
            .addClass(isInfiniteScroll  ? 'infinitescroll' : '')
            .addClass(notInfiniteScroll  ? 'notinfinitescroll' : '')
            .addClass(slideShowVars.hasFeedback ? 'hasfeedback' : '')
            .addClass(slideShowVars.hasBreadCrumb ? 'has-bread-crumb' : 'no-bread-crumb');

        // init tracking on infinitescroll — else init Slick
        if(isInfiniteScroll) {
            let refreshTime = infiniteScrollTracking.getRefreshTime();
            $('.slide-container').each((index, el) => {
                lazyLoadInfiniteScroll(el);
            });

            // removead function is called by insterstial ad creatives, but is not used in infinite slideshows, use empty function to avoid errors
            window.slideShow.triggers.removead = () => {
                return false;
            };

            /* initialize instream ads
               priority should be:
                    1. lazyLoadInt (DTM flag)
                    2. ecd value of 3 (useContentMark boolean)
                    3. then 5 as the default
            */
            let loadInterval = slideShowVars.lazyLoadInt !== undefined ? slideShowVars.lazyLoadInt : (!slideShow.useContentMrk ? 5 : 3);
            instreamAd.init(loadInterval);
            if(slideShowVars.lazyLoadInt === undefined || slideShowVars.lazyLoadInt  !== 0) $('.mobile_adlabelleft').remove(); // do not use 1005 ad pos with instream ads

            infiniteScrollTracking.init();

            // add class of 'first-slide' to show breadcrumb and share icon
            config.slideShowWrapper.addClass('first-slide');

            $('.back-to-top').on('click', () => {
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            });

            $(window).trigger('slideshow:initialized');
            
        } else {
            // TODO: should have a template change to make a cleaner edit, move mark up inside of template container and hide on paginated slideshows with css
            $('.back-to-top').remove();

            // *** init interstitial ad on bp 1
            if(breakpoint === 1 && slideShowVars.hasInterstitial !== undefined && !isMscpApp && !window.ads2_ignore[1522]) interAd.init();

            // update config obj before initializing Slick
            config.configObj.initialSlide = window.slideShow.initialSlide;
            // initialize Slick with config,
            window.slideShow.slider = config.slideContainer.slick(config.configObj);
            lazyLoadSlickSlider(config.slideContainer);
        }

    }).delay(300);

	window.likesConfig = {
		'trackVal': 'ss-cont',
		'iconsToAppend': [
			['.crs-utils','li'],
			['.crs-footer_social','span']
		]
	}		
	$('body').append('<link rel="stylesheet" href="//img.' + getDomain() + 'medscapestatic.com/medscape-core/common/css/global/likes.css" type="text/css" />');
	var likeJs = document.createElement('script');
	likeJs.setAttribute('defer','');
	likeJs.src = '//img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/likes/likes.js';
	document.body.appendChild(likeJs);

    // serves as image loader, when done, will trigger the function 'lazydata:loaded'
    addLazyData();

	cpArticleLoad('slideshow');
}

$(document).ready( initSlideshow );

export { initSlideshow, isInfiniteScroll, isLocal };